export default __webpack_public_path__ + "static/media/settings.e2c39a46.svg";